import React, { useState, createContext } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { themeCreator } from './base';

// Context to handle theme switching
export const ThemeContext = createContext<(themeName: string) => void>(
  () => {

  }
);


const ThemeProviderWrapper = (props : any) => {
  // Retrieve the current theme from local storage or default to 'PureLightTheme'
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme';

  // State to manage the theme name
  const [themeName, setThemeNameState] = useState(curThemeName);

  // Create the theme based on the current theme name
  const theme = themeCreator(themeName);

  // Function to set the theme name and update local storage
  const setThemeName = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    setThemeNameState(themeName);
  };

  return (
    <ThemeContext.Provider value={setThemeName}>
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* Ensures consistent baseline styling */}
        {props.children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProviderWrapper;
